import React from 'react';
import { Observer } from 'mobx-react';
import { Link, useRouteMatch, Route, Switch } from 'react-router-dom';
import {
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import SecurityIcon from '@material-ui/icons/Security';
import NotificationsIcon from '@material-ui/icons/Notifications';
import LinkIcon from '@material-ui/icons/Link';
import { toJS } from 'mobx';
import { FlexDiv, WideBox } from '../../styles/styles';
import AccountSettings from '../AccountSettings';
import Security from '../Security';
import ReferralLink from '../ReferralLink';
import NotificationMgr from '../NotificationMgr';

const Profile = () => {
  const { url } = useRouteMatch();

  return (
    <Observer
      render={() => {
        return (
          <FlexDiv style={{ justifyContent: 'flex-start', marginTop: '2rem' }}>
            <WideBox>
              <Typography variant="h2" gutterBottom>
                Profile Settings
              </Typography>
              <Divider />
              <div style={{ display: 'flex', minHeight: '400px' }}>
                <List
                  style={{
                    width: '300px',
                    borderRight: 'solid 0.5px rgb(224, 224, 224)',
                    marginTop: '10px',
                  }}
                >
                  <ListItem button component={Link} to={`${url}/settings`}>
                    <ListItemIcon>
                      <SettingsIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="General"
                      primaryTypographyProps={{ variant: 'h5' }}
                      secondary="Basic Profile Settings"
                    />
                  </ListItem>
                  <ListItem button component={Link} to={`${url}/security`}>
                    <ListItemIcon>
                      <SecurityIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Security"
                      primaryTypographyProps={{ variant: 'h5' }}
                      secondary="Update Login Password"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={`${url}/notification-settings`}
                  >
                    <ListItemIcon>
                      <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Notifications"
                      primaryTypographyProps={{ variant: 'h5' }}
                      secondary="Manage Notification Settings"
                    />
                  </ListItem>
                  <ListItem button component={Link} to={`${url}/referral-link`}>
                    <ListItemIcon>
                      <LinkIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Referral Link"
                      primaryTypographyProps={{ variant: 'h5' }}
                      secondary="Enjoying Deal Map? Tell A Friend"
                    />
                  </ListItem>
                </List>
                <div style={{ width: '100%' }}>
                  <Switch>
                    <Route
                      exact
                      path={`${url}/settings`}
                      component={AccountSettings}
                    />
                    <Route
                      exact
                      path={`${url}/security`}
                      component={Security}
                    />
                    <Route
                      exact
                      path={`${url}/notification-settings`}
                      component={NotificationMgr}
                    />
                    <Route
                      exact
                      path={`${url}/referral-link`}
                      component={ReferralLink}
                    />
                  </Switch>
                </div>
              </div>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default Profile;
